
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import "./index.scss";

interface StarRatingProps {
  initialRating?: number;
  totalStars?: number;
  onRate?: (rating: number) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ 
  initialRating = 0, 
  totalStars = 5,
  onRate
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hover, setHover] = useState(0);
  const [clickEffect, setClickEffect] = useState<number | null>(null);

  const handleClick = (index: number) => {
    setRating(index);
    setClickEffect(index);
    if (onRate) onRate(index);
    setTimeout(() => setClickEffect(null), 1000);
  };

  // const getEmoji = (score: number) => {
  //   const emojis: Record<number, string> = {
  //     1: "😞", 2: "😕", 3: "😐", 4: "😊", 5: "😍"
  //   };
  //   return emojis[score] || "✨";
  // };

  // const getLabel = (score: number) => {
  //   const labels: Record<number, string> = {
  //     1: "太差了", 2: "不太行", 3: "还不错", 4: "很满意", 5: "超级棒!"
  //   };
  //   return labels[score] || "点击星星评分";
  // };

  return (
    <div className="star-rating-root">
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
        }}
        className="star-list"
      >
        {[...Array(totalStars)].map((_, i) => {
          const index = i + 1;
          const isHighlighted = index <= (hover || rating);
          const showLoop = rating === 0 && hover === 0;

          return (
            <motion.div
              key={index}
              variants={{
                hidden: { y: 10, opacity: 0 },
                visible: { y: 0, opacity: 1 }
              }}
              className="star-item"
            >
              <motion.button
                type="button"
                className="star-button"
                animate={showLoop ? {
                  scale: [1, 1.2, 1],
                  rotate: [0, 5, 0],
                } : {
                  scale: 1,
                  rotate: 0,
                }}
                transition={showLoop ? {
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.15,
                  ease: "easeInOut"
                } : { type: 'spring', stiffness: 400, damping: 10 }}
                whileHover={{ scale: 1.3, rotate: 15 }}
                whileTap={{ scale: 0.8 }}
                onClick={() => handleClick(index)}
                onMouseEnter={() => setHover(index)}
                onMouseLeave={() => setHover(0)}
              >
                <motion.div
                  className="star-glow"
                  animate={showLoop ? {
                    opacity: [0, 0.6, 0],
                    scale: [0.8, 1.3, 0.8]
                  } : {
                    opacity: isHighlighted ? 0.4 : 0
                  }}
                  transition={showLoop ? {
                    duration: 2,
                    repeat: Infinity,
                    delay: i * 0.15,
                  } : { duration: 0.3 }}
                />

                <svg
                  className={`star-svg ${
                    isHighlighted ? 'active' : showLoop ? 'loop' : 'inactive'
                  }`}
                  fill={isHighlighted ? 'currentColor' : 'none'}
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.175 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.382-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                  />
                </svg>

                <AnimatePresence>
                  {clickEffect === index && (
                    <motion.div className="particles-container">
                      {[...Array(8)].map((_, pi) => (
                        <motion.div
                          key={pi}
                          className="particle"
                          initial={{ scale: 0, x: 0, y: 0 }}
                          animate={{ 
                            scale: [0, 1, 0],
                            x: Math.cos(pi * 45 * Math.PI / 180) * 60,
                            y: Math.sin(pi * 45 * Math.PI / 180) * 60,
                          }}
                          transition={{ duration: 0.7, ease: "easeOut" }}
                        />
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.button>
            </motion.div>
          );
        })}
      </motion.div>

      {/* <div className="feedback-area">
        <AnimatePresence mode="wait">
          {(hover > 0 || rating > 0) ? (
            <motion.div
              key={hover || rating}
              initial={{ opacity: 0, scale: 0.8, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: -10 }}
              className="feedback-badge"
            >
              <span className="feedback-emoji">{getEmoji(hover || rating)}</span>
              <div className="feedback-info">
                <span className="feedback-text">{getLabel(hover || rating)}</span>
                <span className="feedback-sub">LEVEL {hover || rating}</span>
              </div>
            </motion.div>
          ) : (
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="prompt-text"
            >
              ✨ 点击星星给予反馈 ✨
            </motion.p>
          )}
        </AnimatePresence>
      </div> */}
    </div>
  );
};

export default StarRating;
